import { Cliente } from '@/interface/cliente.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-cliente',
  templateUrl: './edit-cliente.component.html',
  styleUrls: ['./edit-cliente.component.scss']
})
export class EditClienteComponent implements OnInit {
  @Input() cliente: Cliente;
  clienteForm: FormGroup;
  @Output() updateData = new EventEmitter();
  regiones: Array<any> = []
  provincias: Array<any> = []
  comunas: Array<any> = []
  modalsNumber = 0;

  constructor(private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public generalService: GeneralService,
    private loadingService: LoadingService) {
  }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.clienteForm = this.fb.group({
      id_cliente: [this.cliente.id_cliente, Validators.required],
      nombre: [this.cliente.nombre, Validators.required],
      apellido: [this.cliente.apellido, Validators.required],
      email: [this.cliente.email],
      telefono: [this.cliente.telefono],
      habilitado: [this.cliente.habilitado],
    });
  }

  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true , scrollable: true }).result.then((result) => {
      this.loadingService.setLoading(true)
      //Cerrado/guardado retornando objeto
      this.generalService
        .putEdita("cliente", result.id_cliente, {
          nombre: result.nombre,
          apellido: result.apellido,
          email: result.email,
          telefono: result.telefono,
          habilitado: result.habilitado
        })
        .then(res => {
            this.generalService
              .putEdita("direccion", result.id_direccion, {
                id_cliente: result.id_cliente,
                direccion: result.direccion,
                comuna_id: result.comuna_id,
                detalle: result.detalle,
                principal: true
              })
        })
        .then(res => {
          this.toastr.success('Cliente actualizado exitosamente!');
          this.loadingService.setLoading(false)
          this.updateData.emit();
        })
        .catch(err => {
          this.toastr.error('Error al actualizar!')
          this.loadingService.setLoading(false)
        });
    }, (reason) => {
      this.loadingService.setLoading(false)
      //Cerrasdo por X, ESC, backdrop
    });
  }

  async getDirecciones() {
    try {
      let res = await this.generalService.getObtiene("cliente", this.cliente.id_cliente)
      this.cliente.direccions = res.data.direccions;
    } catch (error) {
      this.comunas = [];
    }
  }
}
